import { defineStore } from 'pinia';

const generateRandomId = () => {
  return `id-${new Date().getTime().toString(36)}-${Math.random()
    .toString(36)
    .substring(2, 9)}`;
};
interface modalStoreStateType {
  modalId: string[];
}
const useModalStore = defineStore('modalStore', {
  state: (): modalStoreStateType => ({
    modalId: [],
  }),
  actions: {
    generateRandomId(): string {
      const randomId = generateRandomId();
      if (this.modalId.includes(randomId)) {
        return this.generateRandomId();
      }
      return randomId;
    },
    dropDomId(id: string) {
      this.modalId = this.modalId.filter((item: string) => item !== id);
    },
  },
});
export default useModalStore;
